import { useSelector, useDispatch } from 'react-redux'
import {
  selectIsVbRemoving,
  selectPreviousImage,
  selectVbImage,
} from '../vb/reducer'
import Spinner from '../components/Spinner.js'
import {
  blurVirtualBackground,
  removeVirtualBackground,
  setVirtualBackground,
} from '../vb/actions'
import { VB_IMAGE_TYPES } from '../vb/constants.js'

function UndoBackgroundButton({ image, index, resultSelected }) {
  const dispatch = useDispatch()
  const isVbRemoving = useSelector(selectIsVbRemoving)
  const vbImage = useSelector(selectVbImage)
  const previousVbImage = useSelector(selectPreviousImage)

  const setToPreviousVb = () => {
    if (!previousVbImage) return

    if (previousVbImage.id) {
      dispatch(
        setVirtualBackground({ image: previousVbImage, popPreviousImage: true })
      )
    } else if (previousVbImage.type === VB_IMAGE_TYPES.blur) {
      dispatch(blurVirtualBackground({ popPreviousImage: true }))
    } else if (previousVbImage.type === VB_IMAGE_TYPES.none) {
      dispatch(removeVirtualBackground({ popPreviousImage: true }))
    }
  }

  return (
    <button
      data-id={`insideImagesContainer_${index}`}
      onClick={setToPreviousVb}
      className="SearchResult__button SearchResult__button-undo"
      tabIndex={resultSelected ? '0' : '-1'}
    >
      {isVbRemoving && image.id === vbImage?.id ? (
        <>
          <Spinner /> Preparing
        </>
      ) : (
        'Undo'
      )}
    </button>
  )
}

export default UndoBackgroundButton
